import { render, staticRenderFns } from "./ModalCadastroCursoFuncionario.vue?vue&type=template&id=1128cf38"
import script from "./ModalCadastroCursoFuncionario.vue?vue&type=script&lang=js"
export * from "./ModalCadastroCursoFuncionario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports